// HD logo (provided by user). Two variants:
// - LOGO_URL: tightly cropped, small dark backing — for the light-bg header.
// - LOGO_HD_URL: original full-resolution for footer/dark surfaces and downloads.
export const LOGO_URL = "/trawelldmc-logo-header.png";
export const LOGO_HD_URL = "/trawelldmc-logo-hd.png";
export const LOGO_DOWNLOAD_URL = "/trawelldmc-logo-hd.png";

export const HERO_BG_URL =
  "https://static.prod-images.emergentagent.com/jobs/9a1067d0-3df8-45e7-af08-266e92626243/images/054d90ddbe8f9bbc2c4c925b4d3a17029e8a3cf9e2e697fb2a7f9906cec685ca.png";

export const AI_AVATAR_URL =
  "https://static.prod-images.emergentagent.com/jobs/9a1067d0-3df8-45e7-af08-266e92626243/images/5efdfa6ead0f0e4225cc10c245fdc780b32f7c6bb467f52ee1ff84fbfb5ad6f9.png";

export const MICE_IMG =
  "https://images.unsplash.com/photo-1571645163064-77faa9676a46?crop=entropy&cs=srgb&fm=webp&w=1920&q=80";

// Distinct hero images for service pages (avoids reuse of MICE_IMG)
export const SERVICE_IMAGES = {
  miceServices:
    "https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=srgb&fm=webp&w=1920&q=80",
  corporate:
    "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?crop=entropy&cs=srgb&fm=webp&w=1920&q=80",
  incentive:
    "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?crop=entropy&cs=srgb&fm=webp&w=1920&q=80",
  planning:
    "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=webp&w=1920&q=80",
};

// Static company profile PDF (served from /public)
export const COMPANY_PROFILE_PDF = "/trawelldmc-company-profile.pdf";

// Social media
export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/trawelldmc?igsh=dml5M2ZmdzFmZnM5",
  linkedin: "https://www.linkedin.com/company/trawell-dmc/",
};

export const DESTINATION_IMAGES = {
  dubai:
    "https://images.unsplash.com/photo-1651063820152-d3e7a27b4d2b?crop=entropy&cs=srgb&fm=webp&w=1920&q=80",
  singapore:
    "https://images.pexels.com/photos/15480509/pexels-photo-15480509.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1920",
  malaysia:
    "https://images.pexels.com/photos/5904675/pexels-photo-5904675.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1920",
  thailand:
    "https://images.unsplash.com/photo-1673627114942-88d7a578e295?crop=entropy&cs=srgb&fm=webp&w=1920&q=80",
  bali:
    "https://images.unsplash.com/photo-1604999333679-b86d54738315?crop=entropy&cs=srgb&fm=webp&w=1920&q=80",
  philippines:
    "https://images.pexels.com/photos/35649530/pexels-photo-35649530.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1920",
  vietnam:
    "https://images.pexels.com/photos/30634746/pexels-photo-30634746.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1920",
  hongkong:
    "https://images.unsplash.com/photo-1536599524557-5f784dd83358?fm=webp&w=1920&q=80",
  cambodia:
    "https://images.unsplash.com/photo-1508009603885-50cf7c579365?crop=entropy&cs=srgb&fm=webp&w=1920&q=80",
  baliId:
    "https://images.unsplash.com/photo-1537996194471-e657df975ab4?crop=entropy&cs=srgb&fm=webp&w=1920&q=80",
  laos:
    "https://images.unsplash.com/photo-1555921015-5532091f6026?crop=entropy&cs=srgb&fm=webp&w=1920&q=80",
  japan:
    "https://images.unsplash.com/photo-1545569341-9eb8b30979d9?crop=entropy&cs=srgb&fm=webp&w=1920&q=80",
};
